module.exports = __webpack_public_path__ + "static/media/hat.0d755ad2.jpg";